import React from 'react';
import { NavLink } from 'react-router-dom';

function NavBar() {
  return (
    <div className="navbar">
      <NavLink className="navlink" to="/login">
        LOG IN
      </NavLink>
      <NavLink className="navlink" to="/home">
        HOME
      </NavLink>
      <NavLink className="navlink" to="/buy_car">
        BUY CAR
      </NavLink>
      <NavLink className="navlink" to="/about">
        ABOUT
      </NavLink>
      {/* <NavLink className="navlink" to="/manufacturers">
        Manufacturers
      </NavLink> */}
    </div>
  );
}

export default NavBar